import {
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Button } from "antd";
import React from "react";
import Fonts from "../../Config/Fonts";
import Icons from "../../Config/Images";
import Colors from "../../theme/Colors";
import BreadcrumbsComponent from "../BreadCrumbs";

const CustomTopView = ({
  breadcrumbs,
  addButtonText,
  exportButtonText,
  rowsPerPage,
  handleRowsPerPageChange,
  rowPerPageLabel,
  onAddButtonClick,
  onExportBtnClick,
  searchValue,
  onSearchChange,
  isOrder=false,
}) => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        marginTop: "12px",
      }}
    >
      <div style={{ width: "20%", marginLeft: "20px" }}>
        <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
      </div>

      <div style={btnInputStyle}>
        <div>
          {!isOrder && (
            <Button
              type="default"
              icon={
                <img
                  src={Icons.addIcon}
                  alt="add icon"
                  style={{ height: "20px", width: "20px" }}
                />
              }
              onClick={onAddButtonClick}
              style={exportBtnStyle}
            >
              {addButtonText}
            </Button>
          )}
          <Button
            onClick={onExportBtnClick}
            type="primary"
            icon={
              <img
                src={Icons.uploadIcon}
                alt="export Icon"
                style={{ height: "20px", width: "20px" }}
              />
            }
            style={addBtnStyle}
          >
            {exportButtonText}
          </Button>
        </div>
      </div>

      <div
        style={{
          marginLeft: "20px",
          width: "24%",
          justifyContent: "end",
          display: "flex",
        }}
      >
        <FormControl
          sx={{
            width: "80%", // Set width to 100% to fill the parent div
            height: "40px", // Set height for the FormControl
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography style={rowPerPageText}>{rowPerPageLabel}</Typography>
          <Select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            sx={{
              width: "35%",
              height: "40px",
              marginLeft: "15px",
              backgroundColor: Colors.white,
              fontSize: 16,
              fontWeight: "300",
              fontFamily: Fonts.Poppins,
              color: Colors.breadCrumbsColor,
              borderRadius: 2,
            }}
          >
            {/* Options for rows per page */}
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </div>

      <div>
        <TextField
          variant="outlined"
          placeholder="Search..."
          value={searchValue}
          onChange={onSearchChange}
          sx={{
            width: "20vw",
            "& .MuiOutlinedInput-root": {
              padding: 0,
              backgroundColor: Colors.white,
              height: "2.5rem",
              "& .MuiInputBase-input": {
                height: "30px",
                fontSize: 16,
                fontWeight: "500",
                fontFamily: Fonts.Poppins,
                color: Colors.searchPlaceholder,
              },
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img
                  src={Icons.searchIcon}
                  style={{ height: 20, width: 20, marginLeft: "10px" }}
                  alt="searchIcon"
                />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};

export const exportBtnStyle = {
  marginTop: "8px",
  marginLeft: "10px",
  height: "40px",
  fontSize: 14,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.white,
  backgroundColor: Colors.darkBlue,
};

export const addBtnStyle = {
  marginTop: "8px",
  marginLeft: "10px",
  height: "40px",
  fontSize: 14,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.white,
  backgroundColor: Colors.adminPrimaryColor,
};

const rowPerPageText = {
  fontSize: 14,
  fontWeight: "500",
  fontFamily: Fonts.Poppins,
  color: Colors.paginationTitle,
};

const btnInputStyle = {
  width: '40%',
  display: 'flex',
}

export default CustomTopView;
